import { NESTED_ROUTES } from 'common/src/routes/BaseRoutes';

import Dashboard from 'portal/src/components/common/Dashboard';
import { DASHBOARD_SLUGS } from 'portal/src/constants/luzmoDashboards';

import { RouteDefinition } from '../routeGenerator';

export const portfolioRouteDefinitions: RouteDefinition[] = [
  {
    element: (
      <Dashboard
        dashboardSlug={DASHBOARD_SLUGS.INTERVAL_DATA_PORTFOLIO.SITES}
      />
    ),
    name: 'Sites',
    path: NESTED_ROUTES.INTERVAL_DATA_PORTFOLIO.SITES,
    description: 'Information about sites in your portfolio',
  },
  {
    element: (
      <Dashboard
        dashboardSlug={DASHBOARD_SLUGS.INTERVAL_DATA_PORTFOLIO.METERS}
      />
    ),
    name: 'Meter Diagnostics',
    path: NESTED_ROUTES.INTERVAL_DATA_PORTFOLIO.METERS,
    description: 'Provides health overview of meters across sites',
  },
  {
    element: (
      <Dashboard
        dashboardSlug={DASHBOARD_SLUGS.INTERVAL_DATA_PORTFOLIO.POINTS}
      />
    ),
    name: 'Point Diagnostics',
    path: NESTED_ROUTES.INTERVAL_DATA_PORTFOLIO.POINTS,
    description:
      'Shows detailed data quality metrics for individual measurement points',
  },
  {
    element: (
      <Dashboard
        dashboardSlug={DASHBOARD_SLUGS.INTERVAL_DATA_PORTFOLIO.ALL_POINTS}
      />
    ),
    name: 'All Points',
    path: NESTED_ROUTES.INTERVAL_DATA_PORTFOLIO.ALL_POINTS,
    description: 'Analyze trends for all available points',
  },
];
